
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Connection, Operation, PermissionCode } from '@/types';
import { currentUserHasPermission } from '@/helpers';
import PracticeNotesDialog from '@/components/PracticeNotesDialog.vue';

@Component({
  components: {
    PracticeNotesDialog,
  },
})
export default class PracticeNotesIcon extends Vue {
  @Prop(Object) readonly operation: Operation | undefined;
  @Prop(Object) readonly connection: Connection | undefined;

  practiceNotesDialog = false

  loading = false

  get hasPracticeNotes(): boolean {
    if (this.operation) return this.operation.hasPracticeNotes === true;
    return this.connection?.hasPracticeNotes === true;
  }

  get iconColor(): string {
    return this.hasPracticeNotes ? 'orange' : 'grey';
  }

  get tooltipText(): string {
    if (this.hasPermission('practiceNotes.edit')) {
      // L'utente ha il permesso per modificare le note
      return this.hasPracticeNotes
        ? 'Mostra o modifica le note alle pratiche'
        : 'Non ci sono note alle pratiche';
    }

    if (this.hasPermission('practiceNotes.show')) {
      // L'utente ha il permesso per mostrare le note
      return this.hasPracticeNotes
        ? 'Mostra le note alle pratiche'
        : 'Non ci sono note alle pratiche';
    }

    return 'Note alle pratiche';
  }

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  async onShow() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.loading) return;

    console.log(`${this.constructor.name}: onShow()`); // eslint-disable-line no-console

    // Se l'utente non ha il permesso per mostrare o modificare, si ferma.
    if (!this.hasPermission('practiceNotes.edit') && !this.hasPermission('practiceNotes.show')) return;

    this.loading = true;
    if (this.operation) {
      // Seleziona l'Operation prima di aprire il dialog
      // await this.$store.dispatch('selectOperation', { id: this.operation.id });
      await this.$store.dispatch('selectLead', { id: this.operation.id });
    } else
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
    }
    this.practiceNotesDialog = true;
    this.loading = false;
  }
}
